import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "80%",
    margin: "0 auto",
    textAlign: "center",
    marginTop: "-100px",
  },
  back: { display: "flex", justifyContent: "flex-start" },
  profileTitle: {
    marginBottom: 7,
  },
  listBox: {
    width: "50%",
    flexDirection: "row",
    textAlign: "left",
    alignItems: "center",
    margin: "0 auto",
    marginTop: 2,
  },
  formControl: {
    width: "50vw",
  },
  button: {
    marginTop: 10,
  },
  buttonArea: {
    justifyContent: "center",
    marginTop: 10,
  },
};
